import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import * as React from "react";
import { WmkLink } from "wmk-link";
import { CompHash } from "./Blocks";
import {
  EmbeddedBlock,
  getRichTextOptions,
  RichTextNode,
  RichTextTopLevelBlock,
} from "wmk-rich-text";

const NullComponent = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
);

const RichTextHyperlink = ({
  to,
  content,
  children,
  target,
}: {
  to: string;
  content?: { value: string }[];
  children: React.ReactNode;
  target?: "blank";
}) => {
  //const target = "blank";
  return (
    <WmkLink to={to} target={target} style={{ display: "inline" }}>
      {children
        ? children
        : Array.isArray(content)
        ? content.map((c, i) => {
            const value = c.value;
            return <NullComponent key={value + i}>{c.value}</NullComponent>;
          })
        : "click here"}
    </WmkLink>
  );
};

const RichTextParagraphs = ({
  content,
  inLink,
}: {
  content: RichTextTopLevelBlock;
  inLink?: boolean;
}) => {
  const Jsx = !inLink
    ? ({ children }: { children: React.ReactNode }) => <div>{children}</div>
    : ({ children }: { children: React.ReactNode }) => (
        <NullComponent>{children}</NullComponent>
      );
  return Array.isArray(content) ? (
    <Jsx>
      {content.map((c, i) => {
        const bold = c.marks[0].type;
        const value = c.value;
        const type = c.nodeType;
        let target = "blank";
        const uri = c.data?.uri ? c.data.uri : "";
        if (type === "hyperlink") {
          target = uri.match(/:\/\/dipra.org/);
        }
        return type === "hyperlink" ? (
          <RichTextHyperlink to={uri} target={target ? "blank" : undefined}>
            <RichTextParagraphs content={c.content} inLink />
          </RichTextHyperlink>
        ) : (
          <NullComponent key={c + i}>
            {bold === "bold" ? <strong>{value}</strong> : value}
          </NullComponent>
        );
      })}
    </Jsx>
  ) : null;
};

export const options = getRichTextOptions({
  renderNode: {
    [INLINES.ENTRY_HYPERLINK]: (
      node: RichTextNode,
      children: React.ReactNode
    ) => {
      const type = node?.reference?.__typename;
      const ErrorComp = () => (
        <>{console.log("no handler for entry link of " + type)}</>
      );
      if (type === "ContentfulWmkBlogs") {
        return (
          <WmkLink
            to={`/blog/${
              node?.reference?.data
                ? node?.reference?.data?.slug
                : node?.reference?.slug
            }`}
            target={"_blank"}
          >
            {children}
          </WmkLink>
        );
      }
      if (type === "ContentfulWmkPages") {
        return (
          <WmkLink
            to={`/${
              node?.reference?.data
                ? node?.reference?.data?.slug
                : node?.reference?.slug
            }`}
          >
            {children}
          </WmkLink>
        );
      }
      return (
        <>
          {children}
          <ErrorComp />
        </>
      );
    },
    [BLOCKS.EMBEDDED_ENTRY]: (node: RichTextNode) => {
      const entry = new EmbeddedBlock(node, CompHash);
      return entry.render();
    },
  },
  //renderText: (text) => text.replace("!", "?")
});
